import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslationCoreModule } from '@qtek/libs/translation-core';
import { collapseAnimation } from '@qtek/shared/utils';

export type QtNetError = 'ws' | 'http' | 'offline';

@Component({
  selector: 'qt-network-error',
  templateUrl: './network-error.component.html',
  styleUrls: ['./network-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [collapseAnimation],
  imports: [MatIconModule, TranslationCoreModule],
})
export class QtNetworkErrorComponent {
  @HostBinding('@collapse') get getCollapsed(): boolean {
    return !this.error;
  }
  @Input() error: QtNetError | null = null;

  readonly ErrNetTitleText = 'Network problems';
  readonly ErrNetCommonText = 'We are experiencing network issues';
  readonly ErrNetWSText =
    'There are problems with WebSocket connection. Application will try to reconnect...';
  readonly ErrNetHttpText =
    'There are problems with HTTP connection. Application will try to reconnect...';
  readonly ErrNetOfflineText =
    'You are offline. Check your internet connection.';
}
